<template>
  <div>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="margin-top: 20px">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编号"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="数量"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="客户名称"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      ORDER_ID: {},
      tableData: [],
      currentOrderFlag: sessionStorage.getItem('currentOrderFlag'),
    };
  },
  created() {
    this.queryTable();
  },
  methods: {
    queryTable() {
      const params = {
        SERVICE_ID: '10022',
        OTYPE: 3,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        CATALOG_ID: Number(sessionStorage.getItem('kindId')),
        SEND_DAY: sessionStorage.getItem('sendDay'),
      };
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      if (sessionStorage.getItem('GROUP_ID') != '') {
        params.GROUP_ID = sessionStorage.getItem('GROUP_ID');
      }
      this.loading = true;
      http.post(params).then((result) => {
        if (result[0].FLAG === 0) {
          if (result[0].DATA.length !== 0) {
            this.loadSearch = false;
            this.tableData = result[0].DATA[0].DATA;
            this.name = result[0].COMPANY_NAME;
          } else {
            this.loadSearch = false;
            this.$message.show({
              text: '暂无数据',
              type: 'warning',
            });
          }
        } else {
          this.loadSearch = false;
          this.$confirm('您选择日期的订单中存在未分类的产品，请先进行分类?', '提示', {
            confirmButtonText: '立即前往',
            type: 'warning',
            showClose: false,
            showCancelButton: false,
          }).then(() => {
            this.$router.push({ name: 'productMatch' });
          });
        }
      }).catch((error) => {
        this.loading = false;
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sendDocument/detailPurchase.vue